import { useQuery } from "@tanstack/react-query";
import { meApi } from "@/api/me";
import { UserMenu } from "@/components/shell/UserMenu";

interface UserPillProps {
  /** When true, render the avatar-only compact form for a collapsed sidebar. */
  collapsed?: boolean;
}

export function UserPill({ collapsed }: UserPillProps = {}) {
  const { data: me } = useQuery({ queryKey: ["me"], queryFn: meApi.get });
  if (!me) return null;
  // The personal org's name doubles as display name (Phase 1.5 dual-write).
  const displayName = me.organizations.find((o) => o.is_personal)?.name ?? me.email ?? "User";
  return (
    <UserMenu
      displayName={displayName}
      email={me.email ?? ""}
      compact={collapsed}
    />
  );
}
